// Local
import Animate from './partials/animate';
import UploadControl from "./partials/upload-control";
import FieldsetRepeatable from "./partials/fieldset-repeatable";
import FestivalHeroAnimation from "./partials/festival-hero-animation";
import FestivalHeroScrollIndicator from "./partials/festival-hero-scroll-indicator";
import NewsCarousel from "./partials/news-carousel";
import ProgramFavorites from "./partials/program-favorites";
import SpeakerShare from "./partials/speaker-share";

window.initDom = ($wrapper) => {
    $wrapper.querySelectorAll('[data-animate]').forEach($item => (new Animate($item)));
    $wrapper.querySelectorAll('[data-festival-hero-animation]').forEach($el => {
        if ($el.dataset.festivalHeroAnimationInitialized) {
            return;
        }

        $el.dataset.festivalHeroAnimationInitialized = 'true';
        new FestivalHeroAnimation($el);
    });
    $wrapper.querySelectorAll('[data-festival-hero-scroll-indicator]').forEach($el => {
        if ($el.dataset.festivalHeroScrollIndicatorInitialized) {
            return;
        }

        $el.dataset.festivalHeroScrollIndicatorInitialized = 'true';
        new FestivalHeroScrollIndicator($el);
    });
    $wrapper.querySelectorAll('[data-news-carousel]').forEach($el => {
        if ($el.dataset.newsCarouselInitialized) {
            return;
        }

        $el.dataset.newsCarouselInitialized = 'true';
        new NewsCarousel($el);
    });
    $wrapper.querySelectorAll('[data-program-favorites]').forEach($el => {
        if ($el.dataset.programFavoritesInitialized) {
            return;
        }

        $el.dataset.programFavoritesInitialized = 'true';
        new ProgramFavorites($el);
    });
    $wrapper.querySelectorAll('[data-speaker-share]').forEach($el => new SpeakerShare($el));
    $wrapper.querySelectorAll('[data-upload]').forEach($el => new UploadControl($el));
    $wrapper.querySelectorAll('[data-form-repeatable]').forEach($el => new FieldsetRepeatable($el));
    $wrapper.querySelectorAll('[data-form]').forEach(async ($el) => {
        const Form = await import('./partials/form');
        (new Form.default($el));
    });
}

(function() {
    window.initDom(document);
})();
